import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HardCopyManagementComponent } from './hard-copy-management/hard-copy-management.component';
import { HardCopyActivityComponent } from './hard-copy-activity/hard-copy-activity.component';
import { ButtonModule } from 'primeng/button';
import { FieldsetModule } from 'primeng/fieldset';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { BptDropdownModule } from 'bpt-ui-library/bpt-dropdown';
import { InputTextareaModule} from 'primeng/inputtextarea';
import { BptNumericInputModule } from 'bpt-ui-library/bpt-numeric-input';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { BptTextInputModule } from 'bpt-ui-library/bpt-text-input';
import { PanelModule } from 'primeng/panel';
import { SharedModule } from '../shared/shared.module';
import { HardcopyActivityConfirmationModalComponent } from './hardcopy-activity-confirmation-modal/hardcopy-activity-confirmation-modal.component';
import { DialogModule } from 'primeng/dialog';
import { DeleteHardCopyComponent } from './delete-hard-copy/delete-hard-copy.component';
import {SpeedDialModule} from 'primeng/speeddial';
import {HardcopyactivityAuditTrialModule} from '../hardcopyactivity-audit-trial/hardcopyactivity-audit-trial.module';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';
import { LabelComponent } from '../shared-components/label/label.component';
@NgModule({
  declarations: [
    HardCopyManagementComponent,
    HardCopyActivityComponent,
    HardcopyActivityConfirmationModalComponent,
    DeleteHardCopyComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    FieldsetModule,
    FormsModule,
    ReactiveFormsModule,
    RadioButtonModule,
    BptDropdownModule,
    InputTextareaModule,
    BptNumericInputModule,
    ToastModule,
    MessagesModule,
    ConfirmDialogModule,
    BptTextInputModule,
    PanelModule,
    SharedModule,
    DialogModule,
    SpeedDialModule,
    HardcopyactivityAuditTrialModule,
    SpinnerComponent,
    LabelComponent
  ],
  exports: [
    HardCopyManagementComponent,
    HardCopyActivityComponent
  ]
})
export class HardCopyModule { }
